import { TaskViewLayoutDTO } from 'models/dto/tasks/taskViewDTO';

let taskViewDiagnosticSequence = 0;

const isTaskViewDiagnosticEnabled = (): boolean => {
  return process.env.NODE_ENV !== 'production';
};

const getNowMs = (): number | undefined => {
  try {
    return typeof performance === 'undefined' ? undefined : Math.round(performance.now());
  } catch {
    return undefined;
  }
};

export const getTaskViewLayoutSummary = (layout: TaskViewLayoutDTO | undefined) => {
  if (!layout) return undefined;

  return {
    revision: layout.revision,
    hasRevision: Boolean(layout.revision),
    version: layout.version,
    viewOrderCount: layout.viewOrder?.length ?? 0,
    viewOrder: layout.viewOrder ?? [],
    hiddenTemplateViewKeys: layout.hiddenTemplateViewKeys ?? [],
    hiddenCustomViewKeys: layout.hiddenCustomViewKeys ?? [],
    hiddenSidebarViewKeys: layout.hiddenSidebarViewKeys ?? [],
    viewMemberFilterKeys: Object.keys(layout.viewMemberFilters ?? {}),
    standardViewFilterOverrideKeys: Object.keys(layout.standardViewFilterOverrides ?? {}),
  };
};

// payload may be a thunk -- callers whose payload is expensive to assemble
// (multi-pass scans, large slices) should pass `() => ({ ... })` so that work
// only runs when diagnostics are actually enabled.
export const logTaskViewDiagnostic = (
  event: string,
  payload?: Record<string, unknown> | (() => Record<string, unknown>),
): void => {
  if (!isTaskViewDiagnosticEnabled()) return;

  const resolvedPayload = typeof payload === 'function' ? payload() : payload;
  const diagnostic = {
    seq: ++taskViewDiagnosticSequence,
    time: new Date().toISOString(),
    nowMs: getNowMs(),
    ...resolvedPayload,
  };

  // Keep these as console diagnostics only: they are intentionally noisy while
  // diagnosing duplicate layout loads/saves and should be easy to filter.
  console.info(`[TaskViewDiagnostics] ${event}`, diagnostic);
};
